import React, { Component } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import debounce from 'lodash/debounce'
import innerText from 'react-innertext'
import Analytics from '..'

const withAnalyticsOnChangeDebounced = (WrappedComponent) =>
  class extends Component {
    static propTypes = {
      wait: PropTypes.number,
      options: PropTypes.object,
      input: PropTypes.shape({
        name: PropTypes.string,
        onChange: PropTypes.func
      }).isRequired,
      meta: PropTypes.shape({ error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]) })
        .isRequired,
      label: PropTypes.any
    }

    static defaultProps = { label: '', wait: 500, options: {} }

    static displayName = `${WrappedComponent.displayName}WithAnalyticsOnChangeDebounced`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.analytics &&
        !isEqual(prevProps.analytics.contexts, this.props.analytics.contexts)
      ) {
        this.analytics = new Analytics(this.props.analytics)
      }
    }

    debouncedAnalyticsEventHandler = debounce(
      () => {
        const {
            input: { name, value, checked },
            meta: { touched, error },
            label
          } = this.props,
          labelText = innerText(label)

        let valueText = `${value}`

        if (typeof value === 'boolean') {
          valueText = value ? 'checked' : 'unchecked'
        }

        if (value === undefined || value === null) {
          valueText = checked ? 'checked' : 'unchecked'
        }

        this.analytics.event({
          name,
          value: valueText || null,
          label: labelText,
          error: (touched && error) || null
        })
      },
      this.props.wait,
      this.props.options
    )

    onChange = (event) => {
      const {
        input: { onChange }
      } = this.props

      onChange(event)

      setTimeout(this.debouncedAnalyticsEventHandler, 0)
    }

    render() {
      const { input, ...props } = this.props

      return <WrappedComponent input={{ ...input, onChange: this.onChange }} {...props} />
    }
  }

export default withAnalyticsOnChangeDebounced
